"use client";
import { createContext, useContext } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/utils/link-provider.tsx
/**
* Default renderer: a plain DOM anchor. It is module-scope and renders only a
* host element (`<a>`), so it never triggers the dynamic-component concern
* described on {@link RenderLink}.
*/
var defaultRenderLink = ({ to, href, ref, ...rest }) => /* @__PURE__ */ jsx("a", {
	ref,
	href: href ?? to ?? void 0,
	...rest
});
var LinkRendererContext = createContext(defaultRenderLink);
/**
* Returns the active link renderer (see {@link RenderLink} for the contract).
* **Call** the result — never render it as JSX:
*
* ```tsx
* const renderLink = useLinkRenderer();
* return renderLink({ ref, href, className, children });
* ```
*/
function useLinkRenderer() {
	return useContext(LinkRendererContext);
}
/**
* Configures how atoms link-like components (Link, `Button` or `Container`
* with `href`) render their anchor, so they delegate to the host app's router.
* See {@link RenderLink} for the renderer contract and the rationale for it
* being a function rather than an injected component.
*
* Defaults to a plain `<a>` when no `renderLink` is provided.
*/
function LinkProvider({ renderLink, children }) {
	return /* @__PURE__ */ jsx(LinkRendererContext.Provider, {
		value: renderLink ?? defaultRenderLink,
		children
	});
}
//#endregion
export { useLinkRenderer as n, LinkProvider as t };

